import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Import global styles
import App from './App'; // Main App component
import reportWebVitals from './reportWebVitals'; // For performance reporting
import { initializeApp, getApps, getApp } from "firebase/app"; // Firebase initialization
import { getDatabase } from "firebase/database"; // Realtime Database
import { getAuth } from "firebase/auth"; // Authentication
import { getFirestore } from "firebase/firestore"; // Firestore
import { getAnalytics } from "firebase/analytics"; // Analytics

// Firebase Configuration
const firebaseConfig = {
  apiKey: "AIzaSyCVnuMLDhLhWgi4fr-Stg0MTNUpKtyAE5s",
  authDomain: "form-builder-2025.firebaseapp.com",
  databaseURL: "https://form-builder-2025-default-rtdb.firebaseio.com",
  projectId: "form-builder-2025",
  storageBucket: "form-builder-2025.appspot.com",
  messagingSenderId: "412676240060",
  appId: "1:412676240060:web:20ebb880951a7fac27d6b9",
  measurementId: "G-36MNM65Q2R"
};

// Initialize Firebase only if not already initialized
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
const auth = getAuth(app);
const db = getFirestore(app);
const realTimeDb = getDatabase(app);
const analytics = getAnalytics(app);

// Set up React rendering
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Measure performance metrics
reportWebVitals(console.log);

export { auth, db, realTimeDb, analytics }; // Export initialized Firebase services for global use
